<template>
  <hm-content title="唤醒会员列表">
    <div class="table-panel flex item-center">
      <el-date-picker
        v-model="dateAndTime"
        type="datetimerange"
        size="small"
        class="mr10"
        start-placeholder="唤醒开始日期"
        end-placeholder="唤醒结束日期"
        :default-time="['00:00:00', '23:59:59']"
      ></el-date-picker>
      <el-input
        clearable
        v-model.trim="guiderKey"
        placeholder="输入会员姓名/手机号"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button type="success" size="small" @click="output">导出</el-button>
    </div>
    <div class="order-list table">
      <el-table
        stripe
        border
        :data="wakeUpMember.records"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realName"
          label="会员姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="mobilePhone"
          width="140px"
          label="手机号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="guiderName"
          label="唤醒导购"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="wakeDate"
          label="唤醒时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="consumeTimes"
          label="购物次数"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="lastShoppingTime"
          label="最近购物时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="regTime"
          label="注册时间"
        ></el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="wakeUpMember.total"
        @current-change="paging"
        layout="total,sizes,   prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
 
 import moment from "moment";
import { mapGetters } from "vuex";
export default {
    
  data() {
    return {
      currentId: "",
      total: 100,
      currentPage: 1,
      pageSize: 10,
      dateAndTime: "",
      startTime: "",
      endTime: "",
      guiderKey: ""
    };
  },
  mounted() {
    this.queryList();
  },
  computed: mapGetters(["wakeUpMember", "allWakeUpMemberList"]),
  watch: {
    dateAndTime(val) {
      this.startTime = val ? moment(val[0]).format("YYYY-MM-DD HH:mm:ss") : "";
      this.endTime = val ? moment(val[1]).format("YYYY-MM-DD HH:mm:ss") : "";
    }
  },
  methods: {
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    queryList() {
      this.$store.dispatch("queryWakeUpMemberList", {
        startTime: this.startTime,
        endTime: this.endTime,
        guiderKey: this.guiderKey,
        pageNo: this.currentPage,
        pageSize: this.pageSize
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    queryAllList() {
      return this.$store.dispatch("queryAllWakeUpMemberList", {
        startTime: this.startTime,
        endTime: this.endTime,
        guiderKey: this.guiderKey,
        pageNo: this.currentPage,
        pageSize: 999999
      });
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(() => {
            const list = this.allWakeUpMemberList;
            const tHeader = [
              "会员姓名",
              "手机号",
              "唤醒导购",
              "唤醒时间",
              "购物次数",
              "最近购物时间",
              "注册时间"
            ];
            const filterVal = [
              "realName",
              "mobilePhone",
              "guiderName",
              "wakeDate",
              "consumeTimes",
              "lastShoppingTime",
              "regTime"
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(tHeader, data, "唤醒会员列表");
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>

<style scoped lang="scss">
.order-detail-list {
  li {
    margin-bottom: 30px;
    font-size: 14px;
  }
  .title {
    font-size: 16px;
    margin: 0;
    margin-bottom: 10px;
  }
  .item {
    line-height: 28px;
    span {
      color: #999;
    }
  }
  .order-table {
    border: 1px solid #ebebeb;
    margin-top: 12px;
    max-width: 500px;
    .order-header {
      border-bottom: 1px solid #ebebeb;
      background: #f5f7fa;
    }
    span {
      padding: 12px;
      width: 25%;
      text-align: center;
      border-right: 1px solid #ebebeb;
    }
    span:last-child {
      border-right: none;
    }
  }
}
</style>
